<template>
    <div v-if="tradeList.length" class="trade-detail">
        <div style="display: flex; align-items: center; padding: 16px">
            <div class="title-line"></div>
            <span class="title-content">代销交易记录</span>
        </div>
        <el-table
            :data="tradeList"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="产品名称" width="200" class-name="fund-offset">
                <template slot-scope="scope">
                    <div style="color: var(--color-text-primary)">
                        {{ scope.row.fundname }}
                    </div>
                    <div style="color: var(--color-text-regular)">
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易类型" align="center">
                <template slot-scope="scope">
                    <span>{{ $cache.getDict("130010", scope.row.businesscode) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="申请日期" align="center">
                <template slot-scope="scope">
                    <div style="color: var(--color-text-primary)">
                        {{ $util.fmtDate(scope.row.transactiondate) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="交易状态" align="center">
                <template slot-scope="scope">
                    <span>{{ formatterCfmStatus(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="确认金额" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.confirmedamount) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="确认份额" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.confirmedvol) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="确认净值" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="手续费" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.charge) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100">
                <template slot-scope="scope">
                    <div class="btns">
                        <el-button
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > pagecount">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="newTrade"
            />
        </el-row>
        <my-dialog
            class="my-dialog-contain"
            title="交易详情"
            :visible="detailVisible"
            width="580px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div v-for="(item, index) in tradeDetail" :key="index" class="trade-item">
                    <span class="label">{{ item.label }}</span>
                    <span class="val">{{ item.val }}</span>
                </div>
                <el-button class="btn ensure" v-on:click="dialogClose">确定</el-button>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import fundApi from "@/api/fund";
import myDialog from "@/components/layout/myDialog.vue";

export default {
    name: "AssetsTradeDetail",
    components: { myDialog },
    mixins: [mixin],
    props: {
        fundcode: {
            type: String,
            default: ""
        },
        queryfundflag: {
            type: String,
            default: "1"
        },
        businessflag: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            curPage: 1, // 当前页
            tradeList: [], // 交易明细
            detailVisible: false, // 是否显示详情弹窗
            tradeDetail: null // 交易详情
        };
    },
    watch: {
        fundcode() {
            this.getTradeList();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    created() {
        this.conf = this.$util.getConfig().const;
        // this.getTradeList();
    },
    methods: {
        // 获取交易明细
        async getTradeList() {
            const _x = {
                keyword: this.fundcode,
                queryfundflag: this.queryfundflag,
                pagesize: this.pagecount,
                pagenum: this.pageoffset,
                appflag: "0",
                sourceflag: "2"
            };
            const res = await fundApi.qryCrmTransConfirm(_x);
            if (res.data) {
                if (this.pageoffset == 1) {
                    this.curPage = 1;
                }
                this.allPage = res.data.total ? res.data.total.toString() : "0";
                this.tradeList = res.data.data;
            }
        },
        // 获取新一页数据
        newTrade(val) {
            this.pageoffset = val;
            this.getTradeList();
        },
        // 获取处理状态
        formatterCfmStatus(row) {
            if (row.businesscode === "026" && row.transstatus == "02") {
                return "申请有效";
            }
            if (row.transstatus == "04") {
                return "下单失败";
            }
            let status = row.status === "01" ? "确认成功" : row.status === "02" ? "确认失败" : "";
            if (!status) {
                if (!this.$util.isEmpty(row.status)) {
                    status = this.$cache.getDict("23061001", row.status) || row.status;
                    if (status == "无需支付" && row.custtag == "1") {
                        status = "支付成功";
                    }
                } else {
                    if (!this.$util.isEmpty(row.paystatus)) {
                        if (row.paystatus == "00") {
                            status = "待支付";
                        } else if (row.paystatus == "01") {
                            status = "支付处理中";
                        } else {
                            if (row.paystatus == "04" && row.custtag == "1") {
                                status = "支付成功";
                            } else {
                                status = this.$cache.getDict("110077", row.paystatus);
                            }
                        }
                    }
                }
            }
            return status;
        },
        // 显示交易详情弹窗
        async showDetail(item) {
            let res = {};
            // 代销数据
            res.data = {};
            if (res.data) {
                const detail = Object.assign(res.data, item);
                if (detail.businesscode == "029") {
                    if (detail.dividendmethod == "0") {
                        // 红利再投资
                        detail.dividendmethoddetail = "3";
                    } else {
                        if (detail.dividendcashbacktype == "1") {
                            // 自动充值至钱柜
                            detail.dividendmethoddetail = "1";
                        } else {
                            // 发放至银行卡
                            detail.dividendmethoddetail = "2";
                        }
                    }
                }
                let array = [];
                array.push({
                    label: "基金名称：",
                    val: `${detail.fundname}[${detail.fundcode}]`
                });
                if (
                    detail.businesscode == "036" &&
                    detail.targetfundname &&
                    detail.targetfundcode
                ) {
                    array.push({
                        label: "转入基金：",
                        val: `${detail.targetfundname}[${detail.targetfundcode}]`
                    });
                }
                array.push({
                    label: "业务类型：",
                    val:
                        this.$cache.getDict("130010", detail.businesscode) +
                        (detail.businesscode == "029"
                            ? "-" + this.$cache.getDict("90273", detail.dividendmethoddetail)
                            : "")
                });
                array.push({
                    label: "销售机构：",
                    val: this.formatterDistributor(item)
                });
                if (item.transactioncfmdate && item.status == "01") {
                    array.push({
                        label: "确认日期：",
                        val: this.$util.fmtDate(detail.transactioncfmdate)
                    });
                }
                array.push({
                    label: "确认金额：",
                    val: this.$util.fmtNum(detail.confirmedamount)
                });
                array.push({
                    label: "确认份额：",
                    val: this.$util.fmtNum(detail.confirmedvol)
                });
                array.push({
                    label: "申请日期：",
                    val: `${this.$util.fmtDate(detail.transactiondate)}`
                });
                if (this.isBuyType(detail.businesscode)) {
                    array.push({
                        label: "申请金额：",
                        val: this.formatterAmount(detail)
                    });
                } else {
                    array.push({
                        label: "申请份额：",
                        val: this.formatterAmount(detail)
                    });
                }
                array.push({
                    label: "支付状态：",
                    val: this.formatterPaystatus(detail)
                });
                array.push({
                    label: "失败原因：",
                    val: item.bankreturnmsg ? item.bankreturnmsg : "--"
                });
                array.push({
                    label: "交易状态：",
                    val: this.formatterCfmStatus(detail)
                });
                array.push({
                    label: "确认净值：",
                    val: this.$util.fmtNum(detail.nav, 4)
                });
                array.push({
                    label: "手续费：",
                    val: this.$util.fmtNum(detail.charge)
                });

                array.push({
                    label: "收费方式：",
                    val: this.$cache.getDict("130000", detail.sharetype)
                });

                this.tradeDetail = array;
                this.detailVisible = true;
            }
        },
        formatterDistributor(row, column, value) {
            return row.distributorname
                ? row.distributorname
                : row.distributorcode
                ? "代销-" + this.$cache.getDict("110070", row.distributorcode)
                : "--";
        },
        formatterAmount(row, column, value) {
            if (this.activeType == "redemptionRecord") {
                return this.$util.fmtNum(row.sellvol);
            } else {
                return this.$util.fmtNum(Number(row.appamount) || Number(row.appvol));
            }
        },
        // 关闭交易详情弹窗
        dialogClose() {
            this.detailVisible = false;
        },
        formatterPaystatus(row) {
            let status = "--";
            if (!this.$util.isEmpty(row.paystatus)) {
                status = this.$cache.getDict("110077", row.paystatus);
            }
            return status;
        },
        // 判断是买入业务还是卖出业务
        isBuyType(businesscode) {
            if ("024,026,036,098".indexOf(businesscode) != -1) {
                return false;
            }
            return true;
        }
    }
};
</script>

<style lang="scss" scoped>
.trade-detail {
    margin-top: 20px;
    box-sizing: border-box;
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 0;
}
.el-table td.el-table__cell div {
    color: var(--color-text-primary);
}
.el-table td.el-table__cell span {
    color: var(--color-text-primary);
}
.el-pagination {
    padding: 16px 0;
    margin-bottom: 0;
}
.dialog-box {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 15px;
    .trade-item {
        display: flex;
        margin-left: 40px;
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        .label {
            width: 150px;
            font-size: 16px;
            text-align: right;
            color: var(--color-text-regular);
        }
        .val {
            font-size: 16px;
            color: var(--color-text-primary);
            max-width: 380px;
        }
        .amount {
            font-size: 16px;
            color: var(--color-primary);
        }
    }

    .el-form-item__label {
        padding: 0;
    }

    .btn {
        margin-top: 18px;
        width: 180px;
        height: 42px;
        background: var(--color-primary);
        font-size: 16px;
        color: var(--color-text-white);
    }

    .ensure {
        margin-left: 200px;
    }

    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 40px;
    }

    .back {
        color: var(--color-text-regular);
        background: var(--button-second-bg);
        border-color: transparent;
    }

    .success-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 20px;
        width: 660px;
        height: 200px;
        border-radius: 6px;
        background: var(--bg-color-lightest);
        .success {
            width: 100px;
            height: 76px;
        }
        .tip {
            margin-top: 23px;
            font-size: 26px;
            font-weight: 500;
            line-height: 22px;
            text-align: center;
            color: var(--color-text-primary);
        }
    }

    .warm-tip {
        margin-left: 20px;
        margin-top: 25px;
        font-size: 14px;
        line-height: 20px;
        color: var(--color-text-regular);
    }
}
.el-dialog__wrapper.prop .el-dialog__header .el-dialog__title {
    font-size: 18px;
}
</style>
